import 'es6-promise/auto';

import * as atc from './add_to_cart_form';
import {Emitter} from './emitter';
import {Swatches} from "./swatches";
import {formatMoney} from '@shopify/theme-currency';

export const
    BLOCK_STATE_IDLE = 'idle',
    BLOCK_STATE_LOADING = 'loading',
    BLOCK_STATE_LOAD_FAILED = 'load_failed',
    BLOCK_STATE_LOADED = 'loaded',
    BLOCK_STATE_SUBMITTING = 'submitting',
    BLOCK_STATE_SUBMIT_FAILED = 'submit_failed';

export class ProductBlock extends Emitter {
    constructor(loader, cart, block, fetchOptions, options = {}) {
        super();
        this.loader = loader;
        this.cart = cart;
        this.block = block;
        this.fetchOptions = fetchOptions;
        this.swatches = null;
        this.options = options;
        this.productHandle = null;
        this.product = null;
        this.ispopup = false;
        this.bundleDiscount = null;
        this.isStatic = false;
        this.swatchesContainer = block.find('.swatches-wrapper');
        this.state = BLOCK_STATE_IDLE;
        this.handleFormSubmitting = this.handleFormSubmitting.bind(this);
        this.handleFormSubmitFailed = this.handleFormSubmitFailed.bind(this);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
        this.handleVariantSelected = this.handleVariantSelected.bind(this);
        this.handleInfoTabClick = this.handleInfoTabClick.bind(this);
        this.singleProductToBundle = this.singleProductToBundle.bind(this);
        this.handleQuantityChanger = this.handleQuantityChanger.bind(this);
        // this.bundleSpecialPrice = this.bundleSpecialPrice.bind(this);
        const staticHandle = block.data('handle');

        const staticAttr = block.data('static');
        if (staticAttr !== undefined && staticAttr !== false)
            this.isStatic = true;
        this.form = new atc.AddToCartForm(cart, block.find('.v4-add-to-cart-form'))
            .on('variantselected', this.handleVariantSelected)
            .on('submitting', this.handleFormSubmitting)
            .on('submitfailed', this.handleFormSubmitFailed)
            .on('submitted', this.handleFormSubmitted)
            .on('quantitychange', this.handleQuantityChanger);
        if (staticHandle) {
            this.loadFromHandle(staticHandle);
            this.freeGifts(staticHandle)
        }
        this.info = $('#v4-product-info-wrapper')
            .on('click', 'a[data-pane]', this.handleInfoTabClick);


        $('#dots-wrapper').find('.dot-control').on('click', this.handleDots);
        $('#strip').find('.image-frame').on('click', this.handleGalleryImage)
    }
    handleGalleryImage(e){
        const slide = $(e.currentTarget).attr('data-slide-to');
        $('#dots-wrapper .dot-control').removeClass('active');
        $("#dots-wrapper .dot-control[data-slide-to*='" + slide + "']").addClass('active');    }
    // handle gallery dots
    handleDots(e) {
        const dots = $('#dots-wrapper .dot-control').removeClass('active');
        const button = $(e.currentTarget);
        button.addClass('active');
    }

    // bundleProduct @boolean
    handleQuantityChanger(e, bundledProduct, discount, activeVariant) {
        if(this.isNumeric(activeVariant)){
            activeVariant = this.getVariants(activeVariant)[0];
        }
        const { block } = this;
        const propertiesArray = {
            _bundle: activeVariant.name,
            _bundle_class: activeVariant.sku,
            _bundle_discount: discount,
            _single_product: true,
            _base_product_qty: 1,
            // _product_price: activeVariant.price / 100
        };

        const isPopup = block.data('popup') ? true : false;
        const propertiesWrapper = this.createPropertiesWrapper();
        if(bundledProduct) {
            for (const item in propertiesArray) {
                const input = this.createInput(item, propertiesArray[item]);
                $(propertiesWrapper).append(input);
            }

            if (isPopup) {
                $('.v4-add-to-cart-popup .v4-add-to-cart-form').find('.bundle-properties').remove();
                $('.v4-add-to-cart-popup .v4-add-to-cart-form').prepend(propertiesWrapper);
                $('.v4-add-to-cart-popup .product-pane .image-frame').prepend(`<div class="saving">Save ${Math.floor(discount)}%</div>`)
            } else {
                $('.v4-single-product-section .v4-add-to-cart-form').find('.bundle-properties').remove();
                $('.v4-single-product-section .v4-product-gallery .featured').prepend(`<div class="discount">Save ${Math.floor(discount)}%</div>`)
                $('.v4-single-product-section .v4-add-to-cart-form').prepend(propertiesWrapper);
            }
        } else {
            if (isPopup) {
                $('.v4-add-to-cart-popup .v4-add-to-cart-form').find('.bundle-properties').remove();
                $('.v4-add-to-cart-popup .product-pane .image-frame .saving').remove();
            } else {
                $('.v4-single-product-section .v4-add-to-cart-form').find('.bundle-properties').remove();
                $('.v4-single-product-section .v4-product-gallery .featured .discount').remove();
            }
        }
    }

    loadFromHandle(handle, bundleDiscount, frequency = null) {
        // if (handle === this.productHandle)
        //     return;
        this.form.setSubscriptionFrequency(frequency);
        const { block } = this;
        if (typeof bundleDiscount !== 'undefined') {
            this.ispopup = true;
            this.bundleDiscount = bundleDiscount;
        } else if (typeof single_product_bundle_discount !== 'undefined' && typeof this.options.class_ProductPage !== 'undefined') {
            this.bundleDiscount = single_product_bundle_discount;
        } else {
            this.bundleDiscount = null;
        }
        this.productHandle = handle;
        this.product = null;
        this.setState(BLOCK_STATE_LOADING);
        this.emit('loading', handle);
        this.loader
            .getProduct(handle, this.fetchOptions)
            .then((data) => this.setProduct(data))
            .catch((error) => this.notifyLoadFailure(error));
        if ($('.v4-add-to-cart-popup-container .cart-bundle-wrapper').length > 0) {
            $('.v4-add-to-cart-popup .v5-upsell-placeholder-collection').html(' ');
            $('.v4-add-to-cart-popup .v5-upsell-popup-heading').remove();
        }
       const qtySelector = block.find('.v4-quantity-selector');
        if(doubled_products[handle]) {
            qtySelector.data('handle', handle);
            qtySelector.find('.step-button.down').prop('disabled', true);
        } else {
            qtySelector.data('handle', 'null');
        }
    }

    setState(newState) {
        this.block
            .toggleClass('loaded', newState === BLOCK_STATE_LOADED)
            .toggleClass('loading', newState === BLOCK_STATE_LOADING)
            .toggleClass('load-failed', newState === BLOCK_STATE_LOAD_FAILED)
            .toggleClass('submitting', newState === BLOCK_STATE_SUBMITTING)
            .toggleClass('submit-failed', newState === BLOCK_STATE_SUBMIT_FAILED)

        this.state = newState;

        this.emit('statechange', newState);
    }

    // transform single product to bundle
    singleProductToBundle(activeVariant) {
        $('.v4-add-to-cart-popup .bundle-properties').remove();
        
        if (this.bundleDiscount === null)
            return;
        let inputs = '';
        const product = this.product,
            doubledProductHandle = product.handle(),
            hasMultipleVariants = product.hasMultipleVariants(),
            activeVariantIndex = activeVariant,
            variant = product.getVariants(activeVariantIndex || 0),
            title = hasMultipleVariants ? variant[0].name : product.title(),
            price = hasMultipleVariants ? variant[0].compare_at_price / 100 : product.ajax.compare_at_price / 100,
            handle = hasMultipleVariants ? this.productHandle + '-' + variant[0].title.toLowerCase() : this.productHandle;
            let globalDiscount = this.bundleDiscount;
            if(typeof custom_variants_discount[variant[0].id] != 'undefined'){
                globalDiscount = custom_variants_discount[variant[0].id];
            }

            let discount = this.variantBundleDiscount(variant[0], globalDiscount);
        let discountedPrice = this.bundlePrice(discount, price),
            propertiesWrapper = this.createPropertiesWrapper(),
            propertiesArray = {
                _bundle: title,
                _bundle_class: handle,
                _bundle_discount: discount,
                _single_product: true,
                _base_product_qty: 1,
                // _product_price: price
            };
            if(this.getCookie('localization') != "US"){
                discountedPrice = price * 100;
            }
            if(doubled_products[doubledProductHandle]) {
                const newQty = doubled_products[doubledProductHandle] + 1;
                const doubledProductPrice = product.price() * newQty;
                discountedPrice = doubledProductPrice;
            }
 
        if (this.ispopup) {
            $('.v4-add-to-cart-popup .v4-add-to-cart-form').find('.bundle-properties').remove();
            $('.v4-add-to-cart-popup .v4-add-to-cart-form').prepend(propertiesWrapper);
            $('.v4-add-to-cart-popup .add-to-cart-button.has-price .price .price').text(formatMoney(discountedPrice, window.moneyFormat));
            $('.v4-add-to-cart-popup .product-pane .image-frame').prepend(`<div class="saving">Save ${Math.floor(discount)}%</div>`)
        } else {
            $('.v4-single-product-section .v4-add-to-cart-form').find('.bundle-properties').remove();
            $('.v4-single-product-section .v4-product-gallery .featured').prepend(`<div class="discount">Save ${Math.floor(discount)}%</div>`)
            $('.v4-single-product-section .v4-add-to-cart-form').prepend(propertiesWrapper);
            $('.v4-single-product-section .add-to-cart-button.has-price .price .price').text(formatMoney(discountedPrice, window.moneyFormat));
        }
        
        for (const item in propertiesArray) {
            const input = this.createInput(item, propertiesArray[item]);
            $(propertiesWrapper).append(input);
        }
        if(discount === 0) {
            $('.v4-add-to-cart-popup .v4-add-to-cart-form').find('.bundle-properties').remove();
            $('.v4-single-product-section .v4-add-to-cart-form').find('.bundle-properties').remove();
            $('.v4-add-to-cart-popup .product-pane .image-frame').find('.saving').remove();
            $('.v4-single-product-section .v4-product-gallery .featured').find('.discount').remove();
        }
        if(this.getCookie('localization') != "US") {
            $('.v4-add-to-cart-popup .product-pane .image-frame').find('.saving').remove();
            $('.v4-single-product-section .v4-product-gallery .featured').find('.discount').remove();
        }
    }

    variantBundleDiscount(variant, discountOrDiscountObj) {
        if(!this.isNumeric(discountOrDiscountObj)) {
            let objVariant = variant;
            if(variant.length > 1) {
                objVariant = variant[0];
            }

            const discounts = discountOrDiscountObj.split(",");
            for(let i = 0; i < discounts.length; i++) {
                const variantDiscount = discounts[i].split(':'),
                discountVariantId = parseFloat(variantDiscount[0]);
                if(objVariant.id === discountVariantId) {
                    return variantDiscount[1];
                }
            }

        } else {
            return discountOrDiscountObj;
        }
        return discountOrDiscountObj
    }

    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    // create hidden properties inputs in add to cart form
    createInput(name, value) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${name}]`;
        input.value = value;

        return input;
    }

    // create properties wrapper where we put properties inputs
    createPropertiesWrapper() {
        const div = document.createElement('div');
        div.className = 'bundle-properties';

        return div;
    }

    // fictitious price in order to show customers bundle price on product page and popup
    bundlePrice(discount, price) {
        const discountAmount = 1 - (discount * 0.01),
            discountedPrice = price * discountAmount;

        return discountedPrice * 100;
    }

    setProduct(product) {
        /* Note the race condition if loadFromHandle() is called during
         * loading. We want to discard fetched product data for anything but
         * the most recently requested handle. */
        const {bundleDiscount , block} = this;
        if (product.handle() !== this.productHandle)
            return;
        if (bundleDiscount !== null) {
            this.product = this.simulateCompareAtPrice(product, bundleDiscount);
        } else {
            this.product = product;
        }

        this.populate(this.product).then(() => {
            this.setState(BLOCK_STATE_LOADED);
            this.emit('loaded');
            new Swatches(this.swatchesContainer, product, this.block.find('select.variant-select'), this.options);
            const handle = product.handle();

            if(doubled_products[handle]) {
                let html = null;
                const newQty = doubled_products[handle] + 1;
                const doubledPrice = this.product.price() * newQty;
                block.find('.add-to-cart-button .price .price').text(formatMoney(doubledPrice, window.moneyFormat));
                if (product.isDiscounted(0)) {
                    html = product.formatPricing(0, {
                        html: true,
                        comparison: true,
                        // label: 'Special Price: ',
                        comparisonLabel: 'Special Price: ',
                        quantity: newQty,
                    });
                }

                $(block).find('.pricing').html(html !== null ? html : '');
            }
        });
    }

    simulateCompareAtPrice(product, discount) {
        const price = product.ajax.price;
        const discountedPrice = this.bundlePrice(discount, price / 100);
        product.ajax.price = discountedPrice;
        product.ajax.compare_at_price = price;
        
        for (var i = 0; i < product.ajax.variants.length; i++) {
            let shouldBeRounded = this.variantRoundDiscount;
            let globalDiscount = discount;
            const variant = product.ajax.variants[i];
            if(typeof custom_variants_discount[variant.id] != 'undefined') {
                globalDiscount = custom_variants_discount[variant.id];
            }

            const variantDiscount = this.variantBundleDiscount(variant, globalDiscount);
            const variantPrice = variant.price;
            const discountedVariantPrice = this.bundlePrice(variantDiscount, variantPrice / 100);
            variant.compare_at_price = variantPrice;
            variant.price = discountedVariantPrice;
            if(this.getCookie('localization') != "US") {
                variant.price = variantPrice;
            }
        }

        return product;
    }

    getCookie(name) {
        var pattern = RegExp(name + "=.[^;]*")
        var matched = document.cookie.match(pattern)
        if(matched){
            var cookie = matched[0].split('=')
            return cookie[1]
        }
        return null;
    }

    notifyLoadFailure(error) {
        console.log('product load failure: ', error);
        this.setState(BLOCK_STATE_LOAD_FAILED);
        this.emit('loadfailed', error);
    }

    handleFormSubmitting(e) {
        this.setState(BLOCK_STATE_SUBMITTING);
    }

    handleFormSubmitted(e) {
        this.setState(BLOCK_STATE_LOADED);
    }

    handleFormSubmitFailed(e) {
        this.setState(BLOCK_STATE_SUBMIT_FAILED);
    }

    handleVariantSelected(e, product, variantIndex) {
        this.updatePricing(product, variantIndex);
        this.updateSaving(product.formatSaving(variantIndex));
        this.emit('variantselected', product, variantIndex);
        this.singleProductToBundle(variantIndex);
    }

    updateSaving(percentage = null) {
        if (percentage !== null)
            $('.v4-single-product-section .v4-product-gallery .featured .discount').html(percentage);
    }

    updateRatings(product) {
        const {block} = this;
        block 
            .find('.shopify-product-reviews-badge, .spr-badge')
            .replaceWith(`<div class="shopify-product-reviews-badge" data-id="${product.ajaxId()}"></div>`);

        try {
            const {SPR} = window;
            if (SPR) {
                SPR.registerCallbacks();
                SPR.initRatingHandler();
                SPR.initDomEls();
                SPR.loadProducts();
                SPR.loadBadges();
            }
        } catch (e) {

        }
    }

    populate(product) {
        const {block, isStatic} = this;
        if (!isStatic) {
            block.toggleClass('long-title', product.hasLongTitle());
            block.find('.title').html(product.title());
            block.find('.collections').html(product.formatCollections());
            block.find('.option-name').html(product.optionName());
            block.find('.description').html(product.description());
            this.updatePricing(product, null);
            this.updateRatings(product);
            this.freeGifts(product.handle());
        }

        this.form.setProduct(product);

        return Promise.resolve();

    }

    freeGifts(handle) {
        const {block} = this;
        const giftProducts = bf_2022_sale[handle];
        block.find('.free-gifts-verbiage').addClass('d-none');
        if(giftProducts) {
            block.find('.free-gifts-verbiage').removeClass('d-none');
            if(giftProducts.length === 1) {
                block.find('.free-gifts-verbiage .free-gifts-title').html('Plus free gift:');
            } else {
                block.find('.free-gifts-verbiage .free-gifts-title').html('Plus free gifts:');
            }
            let html = '';
            for(let i = 0; i < giftProducts.length; i++) {
                const giftProduct = giftProducts[i];
                html += `<li>${giftProduct.name}</li>`;
            }
            block.find('.free-gifts-verbiage .gifts-product-wrapper').html(html);
        }
    }
    
    updatePricing(product, variantIndex) {
        const {block} = this;
        let html = null;
        const handle = product.handle();
        if (product.isDiscounted(variantIndex)) {
            html = product.formatPricing(variantIndex, {
                html: true,
                comparison: true,
                // label: 'Special Price: ',
                comparisonLabel: 'Special Price: '
            });
        }

        if(doubled_products[handle]) {
            const newQty = doubled_products[handle] + 1;
            if (product.isDiscounted(0)) {
                html = product.formatPricing(variantIndex, {
                    html: true,
                    comparison: true,
                    // label: 'Special Price: ',
                    comparisonLabel: 'Special Price: ',
                    quantity: newQty,
                });
            }

        }

        block.find('.pricing').html(html !== null ? html : '');
        block.toggleClass('discounted', html !== null);
    }

    handleInfoTabClick(e) {
        const paneName = $(e.target).data('pane');
        if (!paneName)
            return;

        this.info
            .find('.tabs a')
            .parent()
            .removeClass('active');
        this.info
            .find(`[data-pane="${paneName}"]`)
            .parent()
            .addClass('active');

        this.info
            .find('.panes .pane')
            .removeClass('active')
            .filter(`[data-pane="${paneName}"]`)
            .addClass('active');

        e.preventDefault();
        e.stopPropagation();
    }


}
